/**
 * Retrieves the submission GUID from the URL or localStorage.
 * @returns {string|null} The submission GUID, or null if not found.
 */
export function getAngeionTestParam() {
    const urlParams = new URLSearchParams(window.location.search);
    let angeionTestParams = urlParams.get("angeion_test");

    if (!angeionTestParams) {
        angeionTestParams = localStorage.getItem("_ag_TEST");
    } else {
        localStorage.setItem("_ag_TEST", angeionTestParams);
    }

    return angeionTestParams;
}
